import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import api from '../../config/api';
import { theme } from '../../styles/theme';

const Container = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Card = styled.div`
  background: ${theme.colors.background.paper};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  padding: 2rem;
  max-width: 560px;
  width: 100%;
  text-align: center;
  box-shadow: ${theme.shadows.md};
`;

const Title = styled.h2`
  margin: 0 0 0.5rem 0;
  color: ${theme.colors.text.primary};
`;

const Subtitle = styled.p`
  margin: 0 0 1.5rem 0;
  color: ${theme.colors.text.secondary};
`;

const Button = styled.button`
  padding: 0.75rem 1.25rem;
  border-radius: ${theme.borderRadius.md};
  border: none;
  background: ${theme.colors.primary.main};
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: ${theme.transitions.default};
`;

const ActivateAccount = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState({ state: 'idle', message: 'Set a password and activate your account.' });
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleActivate = async () => {
    try {
      if (!token) {
        setStatus({ state: 'error', message: 'Missing activation token.' });
        return;
      }
      if (password && password.length < 6) {
        setStatus({ state: 'error', message: 'Password must be at least 6 characters.' });
        return;
      }
      if (password !== confirm) {
        setStatus({ state: 'error', message: 'Passwords do not match.' });
        return;
      }
      setLoading(true);
      const body = password ? { password } : {};
      const res = await api.post(`/api/auth/activate/${token}`, body);
      const msg = res?.data?.message || 'Account activated successfully.';
      setStatus({ state: 'success', message: msg });
    } catch (e) {
      const data = e?.response?.data;
      if (data?.login_ready) {
        setStatus({
          state: 'success',
          message: data.error || 'Your account is already activated. Sign in with your password, or use Forgot Password if you need to reset it.',
        });
        return;
      }
      const msg = data?.error || 'Activation failed. The link may be invalid or expired.';
      setStatus({ state: 'error', message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card>
        <Title>{status.state === 'success' ? 'Activation Complete' : status.state === 'error' ? 'Activation Problem' : 'Activate Your Account'}</Title>
        <Subtitle>{status.message}</Subtitle>
        {status.state !== 'success' && (
          <>
            <div style={{ margin: '1rem 0' }}>
              <div style={{ textAlign: 'left', marginBottom: '0.5rem', color: theme.colors.text.secondary, fontSize: '0.9rem' }}>
                Create your password (min 6 characters)
              </div>
              <input
                type="password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: `1px solid ${theme.colors.border.primary}`, background: theme.colors.background.primary, color: theme.colors.text.primary }}
              />
              <input
                type="password"
                placeholder="Confirm password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: `1px solid ${theme.colors.border.primary}`, background: theme.colors.background.primary, color: theme.colors.text.primary, marginTop: '0.5rem' }}
              />
            </div>
            <Button onClick={handleActivate} disabled={loading}>
              {loading ? 'Activating…' : 'Activate & Set Password'}
            </Button>
          </>
        )}
        {status.state === 'success' && (
          <Button onClick={() => navigate('/login')}>Go to Login</Button>
        )}
      </Card>
    </Container>
  );
};

export default ActivateAccount;


